import React, { useState, useEffect } from "react";
import logo from "../images/wrthsLogo.jpg";
import adGoOurHub from "../images/ad_goourhub.jpg"; // <-- import your ad image
import "./VaduAplu.css";

const images = [
  require("../images/wrths1.jpg"),
  require("../images/wrths2.jpg"),
  require("../images/wrths3.jpg"),
  require("../images/wrths4.jpg"),
  require("../images/wrths5.jpg"),
  require("../images/wrths6.jpg"),
 
];


function JamesWreaths() {
  const [dealIndex, setDealIndex] = useState(0);
  const [fade, setFade] = useState(true);

  const deals = [
    
    "Mention GoOurHub to get better price/discounts",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setDealIndex((prev) => (prev + 1) % deals.length);
        setFade(true);
      }, 500);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="vaduaplu-container">
      {/* Header */}
      <header className="vaduaplu-header">
        {/* Left: Logo + Name */}
        <div className="vaduaplu-header-left">
          <img src={logo} alt="Logo" className="vaduaplu-logo" />
          <div className="vaduaplu-header-text">
            <h1 className="vaduaplu-company-name"> Artistic Wreaths by James Deans
              
            </h1>
            
          </div>
        </div>

        {/* Right: Phone + Address */}
        <div className="vaduaplu-header-right">
          <span className="vaduaplu-phone"> jamesdean1955@earthlink.net</span>

<span className="vaduaplu-address">
📍 Booth: Traders Village Booth #415-446 & 516<br />
    📍 Location: 9333 SW Loop 410, San Antonio, TX 78242<br />
    📞 Phone: <a className = "a-links-vaduaplu"href="tel:+12108270196">(210) 827-0196</a>
  <br/>
  <br/>
  
   
  
</span>

        </div>
      </header>

    
      {/* Single Top Box combining Quick Menu & Deals */}
      <div className="vaduaplu-top-box">
        {/* Deals Section */}
        <div className="vaduaplu-top-section">
          <h2 className="vaduaplu-heading">Get Deals</h2>
          {/* Flashing Text */}
          <p className={`vaduaplu-deals-text ${fade ? "fade-in" : "fade-out"}`}>
            {deals[dealIndex]}
          </p>

          {/* Static Image below the deals text */}
          <img
            src={adGoOurHub}
            alt="GoOurHub Ad"
            className="vaduaplu-ad-image"
          />
        </div>

        {/* Quick Menu Section */}
        <div className="vaduaplu-top-section">
          <h2 className="vaduaplu-heading">Our Highlights</h2>
          <div className="vaduaplu-accordion">
            <div className="vaduaplu-accordion-item">
              <input type="checkbox" id="service1" className="hidden-checkbox"defaultChecked />
              <label htmlFor="service1" className="vaduaplu-label" align = "center">
              Our Highlights
              </label>
              <div className="vaduaplu-accordion-content">
              <ul className="vaduaplu-list">
  <li className="vaduaplu-list-item">
    🌼 <strong>Artistic Wreaths by James Deans</strong> – Custom wreaths and handcrafted designs for all occasions.
  </li>
<br/>
  <li className="vaduaplu-list-item">
    🛠️ Specializing in vintage-style wreaths, collectibles, crafts, and decorative glassware   made with artistic vision and attention to detail.
  </li>
  <br/>
  <li className="vaduaplu-list-item">
    🎨 Designer: <strong>James Deans</strong> – Professional Designer with years of creative experience in wreaths & home décor.
  </li>
  <br/>
  <li className="vaduaplu-list-item">
  🤝 Manager: Paul Whitson
    📬 Email: <a className = "a-links-vaduaplu" href="mailto:jamesdean1955@earthlink.net">jamesdean1955@earthlink.net</a><br />
    
  </li>
  <br/>
  <li className="vaduaplu-list-item">
 
  </li>
</ul>







              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content / Gallery */}
      <main className="vaduaplu-main-content">
        <h2 className="vaduaplu-heading">Gallery</h2>
        <div className="vaduaplu-gallery">
          {[...Array(6)].map((_, index) => (
            <img
              key={index}
              src={images[index % images.length]}
              alt={`Work Sample ${index + 1}`}
              className="vaduaplu-image"
            />
          ))}
        </div>
      </main>

      {/* Extra Text Section */}
      <div className="vaduaplu-extra-text">
        <p className="vaduaplu-extra-text-p">
        James Dean’s Artistic Wreaths    </p>
      </div>
    </div>
  );
}

export default  JamesWreaths
  ;
